import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Validators } from '@angular/forms';
import { UserService } from 'src/service/user.service';
import { FormBuilder } from '@angular/forms';

import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from 'src/model/user';
@Component({
  selector: 'app-user-onboarding',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './user-onboarding.component.html',
  styleUrl: './user-onboarding.component.scss',
  standalone: true,
})
export class UserOnboardingComponent implements OnInit {
  userForm = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', []],
    gender: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    birthYear: [
      '',
      [
        Validators.required,
        Validators.min(1900),
        Validators.max(new Date().getFullYear()),
      ],
    ],
    zipCode: ['', [Validators.required]],
    profilePicture: [''],
    acceptedPrivacyPolicy: [false, Validators.requiredTrue],
    acceptedAgb: [false, Validators.requiredTrue],
  });

  loading = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private keycloakService: KeycloakService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const roles = this.keycloakService.getUserRoles();
    if (roles.includes('company')) {
      this.router.navigate(['/company-onboarding']);
    }
    this.keycloakService.loadUserProfile().then((user) => {
      console.log(user);
      this.userForm.patchValue({
        email: user.email,
      });
    });
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.userForm.patchValue({
        profilePicture: file.name,
      });
    }
  }

  onSubmit() {
    if (this.userForm.valid) {
      const formValue = this.userForm.value;
      this.loading = true;

      const user: Partial<User> = {
        firstName: formValue.firstName || '',
        lastName: formValue.lastName || '',
        email: formValue.email || '',
        birthYear: formValue.birthYear || '',
        zipCode: formValue.zipCode || '',
        gender: formValue.gender || '',
        acceptedPrivacyPolicy: formValue.acceptedPrivacyPolicy || false,
        acceptedAgb: formValue.acceptedAgb || false,
      };

      this.userService.createUser(user).subscribe({
        next: (createdUser) => {
          // Update the user store with the newly created user
          this.userService.updateCachedUser(createdUser);

          // Also refresh the user data from the API to ensure consistency
          this.userService.refreshUserInfo().subscribe();

          this.snackBar
            .open(
              'Registrierung erfolgreich. Du wirst weitergeleitet ...',
              'Schließen',
              { duration: 1000 },
            )
            .afterDismissed()
            .subscribe(() => {
              this.loading = false;
              this.router.navigate(['/']);
            });
        },
        error: (error) => {
          this.loading = false;
          console.error('Error creating user', error);
          this.snackBar.open(
            'Fehler beim Erstellen des Benutzers',
            'Schließen',
            { duration: 5000 },
          );
        },
      });
    } else {
      Object.keys(this.userForm.controls).forEach((key) => {
        const control = this.userForm.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }
}
